export default {
  global: {
    colors: {
      brand: "#4F46E5",
      "brand-dark": "#3730A3",
      "accent-1": "#818CF8",
      "accent-2": "#C7D2FE",
      "light-1": "#F9FAFB",
      "light-2": "#F3F4F6",
      "light-3": "#E5E7EB",
      "light-4": "#D1D5DB",
      "light-5": "#9CA3AF",
      "light-6": "#6B7280",
      "dark-1": "#111827",
      "dark-2": "#1F2937",
      "status-ok": "#10B981",
      "status-warning": "#F59E0B",
      "status-error": "#EF4444",
      focus: "rgba(79,70,229,0.3)",
    },
    font: {
      family: "'Inter', 'Poppins', sans-serif",
      size: "15px",
      height: "22px",
    },
    focus: {
      border: {
        color: "brand",
      },
      shadow: {
        color: "rgba(79,70,229,0.2)",
        size: "3px",
      },
    },
    input: {
      weight: 400,
    },
    elevation: {
      light: {
        small: "0 1px 3px rgba(0,0,0,0.08), 0 1px 2px rgba(0,0,0,0.04)",
        medium: "0 4px 16px rgba(0,0,0,0.08), 0 2px 6px rgba(0,0,0,0.04)",
        large: "0 20px 40px rgba(0,0,0,0.10), 0 8px 16px rgba(0,0,0,0.06)",
      },
    },
  },
  button: {
    border: {
      radius: "10px",
    },
    padding: {
      vertical: "12px",
      horizontal: "24px",
    },
    primary: {
      background: {
        color: "brand",
      },
    },
    hover: {
      primary: {
        background: {
          color: "brand-dark",
        },
      },
    },
  },
  formField: {
    border: {
      color: "light-3",
      error: {
        color: "status-error",
      },
      position: "outer",
      side: "all",
      style: "solid",
      size: "1px",
    },
    focus: {
      border: {
        color: "brand",
      },
    },
    label: {
      size: "small",
      color: "light-6",
      weight: 500,
      margin: { bottom: "4px" },
    },
    round: "8px",
    margin: { bottom: "16px" },
  },
  radioButton: {
    border: {
      color: "light-4",
      width: "2px",
    },
    check: {
      color: "brand",
    },
    size: "18px",
    gap: "10px",
  },
  select: {
    icons: {
      color: "light-6",
    },
  },
  layer: {
    zIndex: 999,
    container: {
      zIndex: "998",
    },
    overlay: {
      background: "rgba(17,24,39,0.6)",
    },
  },
};
